import { render } from "./PicCarousel.vue?vue&type=template&id=47817dc2"
import script from "./PicCarousel.vue?vue&type=script&lang=js"
export * from "./PicCarousel.vue?vue&type=script&lang=js"

import "./PicCarousel.vue?vue&type=style&index=0&id=47817dc2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__